import React from 'react'
import '../Services/Services.css'
import website from '../Services/website.svg'
import webapp from '../Services/webapp.svg'
import responsive from '../Services/responsive.svg'
import seo from '../Services/seo.svg'
// import './Services.css'

export default function Services() {
    return (
       <div className="services" id='services'>
        <div className='container '>

          <div className='text-center my-5'><h1 className='services_heading'>MY SERVICES</h1></div>
            <div class="row g-0 row-cols-1 row-cols-md-2 col-12 g-1 py-5">
                <div class="col">
                    <div class="card mx-lg-5 mx-1 py-3 my-2">
                       <img src={website} className="mt-4" alt="" height={"60rem"}/>
                        <div class="card-body text-center">
                            <h5 class="card-title">Website Development</h5>
                            <p class="card-text">"I develop Clean, Responsive, & Pixel perfect Frontend of Websites that converts like crazy. I develop website features that enhance the user experience."</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card mx-lg-5 mx-1 py-3 my-2 ">
                       <img src={webapp} alt="" className="mt-4" height={"60rem"} />
                        <div class="card-body text-center">
                            <h5 class="card-title">Webapp Development</h5>
                            <p class="card-text">"Complex, innovative, responsive, and user-centric web application solutions with close attention to detail that results in the increase in conversions and sales."</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card mx-lg-5 mx-1 py-3  my-2">
                       <img src={responsive} alt="" className="mt-4" height={"60rem"} />
                        <div class="card-body text-center">
                            <h5 class="card-title">Responsive Design</h5>
                            <p class="card-text">"I make websites and applications that are mobile-savvy. Ensuring that it looks and its functions correctly on the different devices and screen sizes."</p>
                        </div>
                    </div>
                </div>
     
                <div class="col">
                    <div class="card mx-lg-5 mx-1 py-3  my-2">
                       <img src={seo} alt="" className="mt-4" height={"60rem"} />
                        <div class="card-body text-center">
                            <h5 class="card-title">SEO Friendly Websites</h5>
                            <p class="card-text">"If a website is not optimized for search engines, it may be difficult for users to find the site through search results. I ensure that the websites are SEO friendly."</p>
                        </div>
                    </div>
                    </div>
                </div>
            
        </div>
       </div>
    )
}
